<div class="editor—wrapper" [id]="ncDomId">
    <div class="toolbar-container" [id]="ncDomId + '-toolbar'"><!-- 工具栏 --></div>
    <div class="editor-container" [id]="ncDomId + '-editor'"><!-- 编辑器 --></div>
</div>